import applicationRepository from './ja-JP/applicationRepository';
import component from './ja-JP/component';
import deploymentOperations from './ja-JP/deploymentOperations';
import eventEngine from './ja-JP/eventEngine';
import globalHeader from './ja-JP/globalHeader';
import menu from './ja-JP/menu';
import pages from './ja-JP/pages';
import projectSettings from './ja-JP/projectSettings';
import pwa from './ja-JP/pwa';
import settingDrawer from './ja-JP/settingDrawer';
import settings from './ja-JP/settings';
import system from './ja-JP/system';
import workbench from './ja-JP/workbench';

export default {
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.banner.title': 'AIソフトウェア工場',
  'app.banner.subtitle':
    'ソフトウェア全ライフサイクルのインテリジェント管理システム',
  'app.footer.copyright': '2026 Coral Wisdom (Beijing) Technology Co., Ltd.',
  'app.preview.down.block':
    'このページをローカルプロジェクトにダウンロードしてください',
  'app.workbench.link.fetch-blocks': '',
  'app.workbench.link.block-list': '',
  ...globalHeader,
  ...applicationRepository,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...projectSettings,
  ...component,
  ...deploymentOperations,
  ...eventEngine,
  ...pages,
  ...workbench,
  ...system,
};
